module.exports = __webpack_public_path__ + "img/sparks-04.e35935af.png";